import { ActiveUsersAndResourcesMode, QueryFilters, QueryFiltersDomainOnly } from '../types';

export const universalMFAQueryKeys = {
    all: ['universalMFA'] as const,
    domains: () => [...universalMFAQueryKeys.all, 'domains'] as const,

    metrics: () => [...universalMFAQueryKeys.all, 'metric'] as const,

    mfaPolicies: () => [...universalMFAQueryKeys.metrics(), 'mfaPolicies'] as const,

    protectedUsers: (filters: QueryFiltersDomainOnly) =>
        [...universalMFAQueryKeys.metrics(), 'protectedUsers', filters] as const,

    lastSync: () => [...universalMFAQueryKeys.metrics(), 'lastSync'] as const,

    configuration: () => [...universalMFAQueryKeys.all, 'configuration'] as const,

    mfaAuthentications: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'mfaAuthentications', filters] as const,

    mfaTriggerRate: (filters: QueryFilters) => [...universalMFAQueryKeys.metrics(), 'mfaTriggerRate', filters] as const,

    policyType: () => [...universalMFAQueryKeys.metrics(), 'policyType'] as const,

    medianMfa: (filters: QueryFilters) => [...universalMFAQueryKeys.metrics(), 'medianMfa', filters] as const,

    bridgeMfaPolicies: () => [...universalMFAQueryKeys.metrics(), 'bridgeMfaPolicies'] as const,

    mfaAllAuthenticationsTraffic: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'mfaAllAuthenticationsTraffic', filters] as const,

    mfaAuthenticationsTraffic: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'mfaAuthenticationsTraffic', filters] as const,

    mfaResponse: (filters: QueryFilters) => [...universalMFAQueryKeys.metrics(), 'mfaResponse', filters] as const,

    authenticationTypeSummary: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'authenticationTypeSummary', filters] as const,

    protocolTypeSummary: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'protocolTypeSummary', filters] as const,

    tokenDistributionSummary: (filters: QueryFilters) =>
        [...universalMFAQueryKeys.metrics(), 'tokenDistributionSummary', filters] as const,

    topDailyMfa: (filters: QueryFilters) => [...universalMFAQueryKeys.metrics(), 'topDailyMfa', filters] as const,

    activeUsers: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...universalMFAQueryKeys.metrics(), 'activeUsers', filters, mode] as const,

    activeResources: (filters: QueryFiltersDomainOnly, mode: ActiveUsersAndResourcesMode) =>
        [...universalMFAQueryKeys.metrics(), 'activeResources', filters, mode] as const,

    riskyUsers: (filters: QueryFiltersDomainOnly) =>
        [...universalMFAQueryKeys.metrics(), 'riskyUsers', filters] as const,

    riskyResources: (filters: QueryFiltersDomainOnly) =>
        [...universalMFAQueryKeys.metrics(), 'riskyResources', filters] as const,

    riskyIndicators: (filters: QueryFiltersDomainOnly) =>
        [...universalMFAQueryKeys.metrics(), 'riskyIndicators', filters] as const,

    insights: () => [...universalMFAQueryKeys.all, 'insights'] as const
} as const;
